import React, { Component } from 'react'
import Iframe from 'react-iframe';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withTheme } from 'styled-components';

import {
  TxtConfirmBlastReport,
  TxtSuccessBlastReport
} from 'fixtures/texts';
import { BLAST_DAILY_REPORT } from 'fixtures/api';
import IconPng from 'atoms/IconPng';
import { TxtLink } from 'atoms/Texts';
import { ButtonReg } from 'atoms/Buttons';
import ConfirmModal from 'organisms/ConfirmModal';
import ModalPage from 'templates/ModalPage';
import { postNewData } from 'services/cmsService';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { RoundedWrapper } from './styles'

const ic_arrow_left = require('App/assets/images/ic_arrow_left.png');

class DetailDailyReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reportUri: null,
      isShowModal: false,
      isConfirmed: false,
      isBlasted: false,
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
  }

  componentDidUpdate() {
    const { REPORT_URL } = process.env
    const { match: { params: { id } }, viewState: { isLoading } } = this.props
    const { isConfirmed, isShowModal, isBlasted } = this.state

    if (isLoading) {
      const report = id.split('&')
      let pitInspectionsUrl = ''
      let romInspectionsUrl = ''
      report.forEach(r => {
        if (r.includes('pit')) {
          pitInspectionsUrl += 'PIT_INSPECTION_ID=' + r.split('=')[1]
        }
        if (r.includes('rom')) {
          romInspectionsUrl += 'ROM_INSPECTION_ID=' + r.split('=')[1]
        }
      })
      this.setState({ reportUri: `${REPORT_URL}BEK_DAILY_REPORT_MAIN&${pitInspectionsUrl}${romInspectionsUrl}` }, () => {
        this.props.toggleIsLoading(false)
      })
    }

    if (isConfirmed && isShowModal && !isBlasted) {
      this.blastReport()
    }
  }

  switchModal() {
    const { isShowModal } = this.state
    this.setState({ isShowModal: !isShowModal })
  }

  switchIsConfirmed() {
    const { isConfirmed } = this.state
    this.setState({ isConfirmed: !isConfirmed })
  }

  switchIsBlasted() {
    const { isBlasted } = this.state
    this.setState({ isBlasted: !isBlasted })
  }

  async blastReport() {
    const { match: { params: { id } } } = this.props
    try {
      const report = id.split('&')
      let pitInspectionId = []
      let romInspectionId = []
      report.forEach(r => {
        if (!r.includes('preview')) {
          const romInspection = r.split('=')[1]
          const reportIds = romInspection ? romInspection.split(',') : []
          if (r.includes('pit')) {
            pitInspectionId = [...reportIds]
          }
          if (r.includes('rom')) {
            romInspectionId = [...reportIds]
          }
        }
      })
      const bodyObj = { pitInspectionId, romInspectionId }
      const res = await postNewData(BLAST_DAILY_REPORT, bodyObj)
      if (res && res.message) {
        this.switchModal()
        this.switchIsConfirmed()
        throw res.message 
      } else {
        this.switchIsBlasted()
        this.switchIsConfirmed()
      }
    } catch (error) {
      this.switchModal()
      this.switchIsConfirmed()
      alert(error)
    }
  }

  onCloseModal() {
    const { history: { goBack } } = this.props
    const { isShowModal, isBlasted } = this.state
    if (isShowModal && isBlasted) {
      this.switchModal()
      this.switchIsBlasted()
      goBack()
    } else {
      this.switchModal()
    }
  }

  getIframeHeight() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w <= 768 ? `${h - 334}px` : `${h - 250}px`
  }

  render() {
    const { theme, match: { params: { id } }, history: { goBack }, viewState: { isLoading } } = this.props
    const { reportUri, isShowModal, isBlasted } = this.state
    const modalConfig = {
      width: '391px',
      height: '452px'
    }
    return (
      <div>
        <ModalPage
          isOpen={isShowModal}
          onBackgroundClick={this.onCloseModal.bind(this)}
          contentChild={
            <ConfirmModal
              isSuccess={isBlasted}
              fnClose={this.onCloseModal.bind(this)}
              fnConfirm={this.switchIsConfirmed.bind(this)}
              fnBack={this.onCloseModal.bind(this)}
              txtConfirm={TxtConfirmBlastReport}
              txtSuccess={TxtSuccessBlastReport}
            />
          }
          {...modalConfig}
        />
        <TxtLink weight={'bold'} color={theme.mocaPurple} size={'14'} showPointer onClick={() => goBack()}>
          <IconPng srcIcon={ic_arrow_left} showPointer={true} mr={'8px'} mb={'3px'} size={'auto'} h={'13'} />
          Back to Daily Report
        </TxtLink>
        {!isLoading &&
          <RoundedWrapper>
            {id.includes('preview') &&
              <ButtonReg
                btnTxt={'Blast Report'}
                width={'127px'}
                height={'40px'}
                margin={'0 0 16px 0'}
                onClick={this.switchModal.bind(this)}
              />
            }
            <div class="mb-3">
              <Iframe
                url={reportUri}
                width="100%"
                height={this.getIframeHeight()}
                display="initial"
                position="relative"
                frameBorder="0" />
            </div>
          </RoundedWrapper>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(DetailDailyReport)
  )
);